import React from "react";

import Link from './Link';
import { Link as AppLink } from 'react-router-dom';
import FavouriteProducts from "./options/FavouriteProducts";
import LastViewed from "./options/LastViewed";
import SearchHistory from "./options/SearchHistory";
import {withRouter} from "react-router-dom";
import {_t} from './../../i18n/lang';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faHistory, faHeart, faSearch, faEnvelope, faTimes} from '@fortawesome/free-solid-svg-icons'


const options = {
    LAST_VIEWED_PRODUCTS: 'LAST_VIEWED_PRODUCTS',
    FAVOURITE_PRODUCTS: 'FAVOURITE_PRODUCTS',
    SEARCH_HISTORY: 'SEARCH_HISTORY',
}

class Sidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeOption: ''
        };

        this.handleOptionSelect = this.handleOptionSelect.bind(this);
        this.handleCloseOption = this.handleCloseOption.bind(this);
        this.handleContactClick = this.handleContactClick.bind(this);
    }

    handleOptionSelect(value) {
        this.setState({
            activeOption: value,
        });
    }

    handleCloseOption() {
        this.setState({
            activeOption: null,
        });
    }

    handleContactClick() {
        this.props.history.push({
            pathname: '/contact-message',
            state: {
                previousPathname: location.pathname,
            },
        });
    }

    render() {
        let menu = null;
        let closeButton = null;

        if (this.state.activeOption) {
            closeButton = <a className="sidebar-close" onClick={this.handleCloseOption}><FontAwesomeIcon icon={faTimes}/></a>
        }

        if (!this.state.activeOption) {
            menu = (<React.Fragment>
                <Link icon={<FontAwesomeIcon icon={faHistory} size="2x"  color="white"/>}
                      optionName={options.LAST_VIEWED_PRODUCTS}
                      onLinkSelect={this.handleOptionSelect}
                />
                <Link icon={<FontAwesomeIcon icon={faHeart} size="2x"  color="white"/>}
                      optionName={options.FAVOURITE_PRODUCTS}
                      onLinkSelect={this.handleOptionSelect}/>
                <Link icon={<FontAwesomeIcon icon={faSearch} size="2x"  color="white"/>}
                      optionName={options.SEARCH_HISTORY}
                      onLinkSelect={this.handleOptionSelect}
                />

                <a className="link" onClick={this.handleContactClick}>
                    {<FontAwesomeIcon icon={faEnvelope} size="2x"  color="white"/>}
                </a>
            </React.Fragment>);
        }

        return <div className="sidebar d-none d-sm-block">
            {menu}

            {closeButton}

            {this.state.activeOption == options.FAVOURITE_PRODUCTS && <FavouriteProducts/>}
            {this.state.activeOption == options.LAST_VIEWED_PRODUCTS && <LastViewed/>}
            {this.state.activeOption == options.SEARCH_HISTORY && <SearchHistory/>}
        </div>
    }
}

export default withRouter(Sidebar);